import {
  Divider,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import { useState } from "react";

export interface RowMenuItem {
  key: string;
  label: string;
  onClick: () => void;
  danger?: boolean;
  /** A write Client View does not allow: shown, but off. */
  readOnly?: boolean;
  /** A line above this item. */
  dividerBefore?: boolean;
}

/** The three dots at the end of a row. */
export default function RowMenu({
  label,
  items,
  disabled = false,
}: {
  label: string;
  items: RowMenuItem[];
  disabled?: boolean;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (items.length === 0) return null;
  return (
    <>
      <IconButton
        size="small"
        aria-label={label}
        disabled={disabled}
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(event.currentTarget);
        }}
      >
        <MoreVert fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {items.flatMap((item) => [
          ...(item.dividerBefore ? [<Divider key={`${item.key}-line`} />] : []),
          <MenuItem
            key={item.key}
            disabled={item.readOnly}
            onClick={() => {
              setAnchor(null);
              item.onClick();
            }}
            sx={item.danger ? { color: "error.main" } : undefined}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ fontSize: 13 }}
            />
          </MenuItem>,
        ])}
      </Menu>
    </>
  );
}
